import { mediaQueries, type Screen } from "./screens";

export function sizes(fallback: string, breakpoints: Partial<Record<Screen, string>> = {}) {
  const sizes: Array<string> = [];

  if (breakpoints["2xl"]) {
    sizes.push(`${mediaQueries["2xl"]} ${breakpoints["2xl"]}`);
  }

  if (breakpoints.xl) {
    sizes.push(`${mediaQueries.xl} ${breakpoints.xl}`);
  }

  if (breakpoints.lg) {
    sizes.push(`${mediaQueries.lg} ${breakpoints.lg}`);
  }

  if (breakpoints.md) {
    sizes.push(`${mediaQueries.md} ${breakpoints.md}`);
  }

  if (breakpoints.sm) {
    sizes.push(`${mediaQueries.sm} ${breakpoints.sm}`);
  }

  sizes.push(fallback);

  return sizes.join(",");
}
